<template>
  <div>
    <el-tabs v-model="propertyTab">
      <el-tab-pane label="Primary Agent" name="primary-agent">
        <!-- Primary Agent Chart -->
        <v-chart :forceFit="true" renderer="svg" :height="graphHeight" :data="ticketCountByPrimaryAgent" :scale="graphScale">
          <v-tooltip/>
          <v-axis/>
          <v-bar position="name*count"/>
        </v-chart>
        <!-- / Primary Agent Chart -->

        <!-- Primary Agent Table -->
        <table class="table mb-0 table-centered">
          <thead class="thead-light">
          <tr>
            <th>Agent</th>
            <th># Tickets Where Primary Agent</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="agent in ticketCountByPrimaryAgent">
            <th scope="row">{{ agent.name }}</th>
            <td>{{ agent.count }}</td>
          </tr>
          </tbody>
        </table>
        <!-- / Primary Agent Table -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "AgentAnalytics",
  data() {
    return {
      propertyTab: 'primary-agent',

      graphHeight: 350,
      graphScale: [{
        dataKey: 'count'
      }]
    }
  },
  computed: {
    ...mapGetters('reportEditor', {
      results: 'results',
      agents: 'agents'
    }),

    agentsToShow() {
      return _.filter(this.agents, agent => {
        return agent.is_cx;
      });
    },

    ticketCountByPrimaryAgent() {
      let counts = [];
      // _.each(this.agents, agent => {
      _.each(this.agentsToShow, agent => {
        counts.push({
          name: agent.name,
          count: this.determineNumberOfTicketsWherePrimaryAgentIs(agent)
        });
      });
      return counts;
    }
  },
  methods: {
    determineNumberOfTicketsWherePrimaryAgentIs(agent) {
     return _.filter(this.results, ticket => {
       return ticket.agent_id === agent.id;
     }).length;
    }
  }
}
</script>

<style scoped>

</style>